// import cernsearchIcon from 'static/cernsearch_icon.png';
import codimdIcon from 'static/codimd_icon.png';
import confluenceIcon from 'static/confluence_icon.png';
import discourseIcon from 'static/discourse_icon.png';
import eosIcon from 'static/eos_icon.png';
import gitlabIcon from 'static/gitlab_icon.png';
import googleWorkspaceIcon from 'static/google_workspace_icon.png';
import grafanaIcon from 'static/grafana_icon.png';
import jiraIcon from 'static/jira_icon.svg';
import matomoIcon from 'static/matomo_icon.png';
import mkdocsIcon from 'static/mkdocs_icon.png';
import msFormsIcon from 'static/ms_forms_icon.svg';
import nexusIcon from 'static/nexus_icon.png';
import overleafIcon from 'static/overleaf_icon.png';
import paasIcon from 'static/paas_icon.png';
import sentryIcon from 'static/sentry_icon.png';
import sharepointIcon from 'static/sharepoint_icon.png';
import twikiIcon from 'static/twiki_icon.gif';
import wordpressIconDark from 'static/wordpress_icon_dark.png';

import communicationIcon from './icons/communication.png';
import documentationIcon from './icons/documentation.png';
import hostingIcon from './icons/hosting.png';
import monitoringIcon from './icons/monitoring.png';
import softwareDevIcon from './icons/software-dev.png';
import webContentIcon from './icons/web-content.png';

export const UsabilityOptions = {
  EASY: 'easy',
  MEDIUM: 'medium',
  ADVANCED: 'advanced',
};

export const webContentManagementServices = {
  wordpress: {
    icon: wordpressIconDark,
    title: 'Wordpress - Content Management System',
    recommended: 'Blogs, community and news sites',
    infoUrl: 'https://wordpress.docs.cern.ch/',
    usability: UsabilityOptions.MEDIUM,
    url: '/wordpress',
  },
  sharepoint: {
    icon: sharepointIcon,
    title: 'SharePoint Online - Collaborative platform',
    recommended:
      'Projects needing more advanced features for content sharing, collaboration, document management and workflows',
    infoUrl: 'https://sharepoint.docs.cern.ch',
    usability: UsabilityOptions.MEDIUM,
    url: 'https://cern.service-now.com/service-portal?id=sc_cat_item&name=SharePoint-Online&se=Sharepoint-Service',
  },
};

const documentationServices = {
  mkdocs: {
    icon: mkdocsIcon,
    title: 'MkDocs (GitLab Pages) - Documentation Generator',
    recommended: 'Software teams to publish documentation of their software',
    infoUrl: 'https://how-to.docs.cern.ch/',
    usability: UsabilityOptions.MEDIUM,
    url: '/gps',
  },
  twiki: {
    icon: twikiIcon,
    title: 'TWiki - Wiki Application',
    recommended: 'Project teams to build their knowledge base',
    infoUrl: 'https://it-dep-cda.web.cern.ch/it-dep-cda/services/twiki/',
    usability: UsabilityOptions.EASY,
    url: 'https://twiki.cern.ch/',
  },
  codimd: {
    icon: codimdIcon,
    title: 'CodiMD - Online Text Editor',
    recommended:
      'Collaborative note taking in real time, excellent for meeting minutes and drafts of documentation',
    infoUrl: 'https://it-dep-cda.web.cern.ch/it-dep-cda/services/codimd/',
    usability: UsabilityOptions.EASY,
    url: 'https://codimd.web.cern.ch',
  },
  overleaf: {
    icon: overleafIcon,
    title: 'Overleaf - Online LaTeX Editor',
    recommended: 'Articles, papers, publications',
    infoUrl: 'https://authoring.web.cern.ch/',
    usability: UsabilityOptions.MEDIUM,
    url: 'https://www.overleaf.com/org/cern#overview',
  },
  confluence: {
    icon: confluenceIcon,
    title: 'Confluence - Content collaboration and management',
    recommended: 'Teams that need a workspace where knowledge and collaboration meet',
    infoUrl:
      'https://cern.service-now.com/service-portal?id=service_element&name=collaborative-editing',
    usability: UsabilityOptions.MEDIUM,
    url: 'https://confluence.cern.ch/',
  },
  googleWorkspace: {
    icon: googleWorkspaceIcon,
    title: 'Google Workspace - Google collaboration tools',
    recommended: 'Different collaboration tool domains',
    infoUrl: 'https://google-workspace.docs.cern.ch/',
    usability: UsabilityOptions.EASY,
    url: 'https://google-workspace-portal.web.cern.ch/',
  },
};

export const communicationServices = {
  discourse: {
    icon: discourseIcon,
    title: 'Discourse - Forum',
    recommended: 'Communities to exchange on problems and solutions',
    infoUrl: 'https://discourse.docs.cern.ch',
    usability: UsabilityOptions.EASY,
    url: 'https://forum-catalogue.web.cern.ch/',
    docsUrl: 'https://discourse.docs.cern.ch/1._Installation/1-create-new-discourse-instance/',
  },
  msforms: {
    icon: msFormsIcon,
    title: 'Microsoft Forms - Survey Tool',
    recommended: 'Lightweight surveys',
    infoUrl: 'https://cern.service-now.com/service-portal?id=service_element&name=online-survey',
    usability: UsabilityOptions.EASY,
    url: 'https://forms.office.com',
  },
};

const hostingServices = {
  webeos: {
    icon: eosIcon,
    title: 'WebEOS - Websites backed by EOS',
    recommended:
      'Lightweight official and personal websites, EOS content publishing. Easiest choice for those using EOS for professional activities and wanting to share online their results with others.',
    infoUrl: 'https://webeos.docs.cern.ch/',
    usability: UsabilityOptions.MEDIUM,
    url: '/webeos',
  },
  paas: {
    icon: paasIcon,
    title: 'PaaS - Platform-as-a-Service, Application Hosting',
    recommended: 'Software Teams to deploy and host their self-made software',
    infoUrl: 'https://paas.docs.cern.ch/',
    usability: UsabilityOptions.ADVANCED,
    url: '/paas',
  },
};

const softwareDevelopmentServices = {
  gitlab: {
    icon: gitlabIcon,
    title: 'GitLab - Source Code Control',
    recommended:
      'Software developers for code versioning, code review, continous integration and issue tracking',
    infoUrl: 'https://cern.service-now.com/service-portal?id=kb_article&n=KB0003137',
    usability: UsabilityOptions.MEDIUM,
    url: 'https://gitlab.cern.ch/',
  },
  jira: {
    icon: jiraIcon,
    title: 'Jira - Issue Tracking',
    recommended: 'Project teams to manage issues and track bugs',
    infoUrl:
      'https://cern.service-now.com/service-portal/report-?id=service_element&name=JIRA-service',
    usability: UsabilityOptions.MEDIUM,
    url: 'https://its.cern.ch/',
  },
  nexus: {
    icon: nexusIcon,
    title: 'Nexus - Artifact Repository Manager',
    recommended: 'Software teams who need to manage binaries and build artifacts',
    warning:
      'Please note that the recommended solution for artifact management is GitLab Package Registry',
    infoUrl: 'https://gitlab.cern.ch/vcs/nexus-cern-operator/-/blob/master/README.md',
    usability: UsabilityOptions.ADVANCED,
    url: '/nexus',
  },
  // elasticsearch: {
  //   icon: cernsearchIcon,
  //   title: 'CERN Search as a Service',
  //   recommended:
  //     'Software Teams and Site Owners wishing to have their pages or application content indexed and searchable in the global CERN Search',
  //   infoUrl: 'https://cern-search.docs.cern.ch/',
  //   usability: UsabilityOptions.ADVANCED,
  //   url: 'https://cern.service-now.com/service-portal?id=service_element&name=cern-search-service',
  // },
};

const monitoringServices = {
  sentry: {
    icon: sentryIcon,
    title: 'Sentry - Application Monitoring',
    recommended:
      'Software teams for monitoring of their applications and identifying issues in real-time.',
    infoUrl: 'https://sentry.docs.cern.ch/',
    usability: UsabilityOptions.MEDIUM,
    url: 'https://sentry.docs.cern.ch/how-to/request/',
  },
  grafana: {
    icon: grafanaIcon,
    title: 'Grafana - Dashboards',
    recommended: 'Analytics and interactive visualization of data',
    infoUrl: 'https://monit.docs.cern.ch/grafana/description',
    usability: UsabilityOptions.MEDIUM,
    url: 'https://monit.docs.cern.ch/grafana/description',
  },
  matomo: {
    icon: matomoIcon,
    title: 'Matomo - Web Analytics',
    recommended: 'Website visits tracking and reporting',
    infoUrl: 'https://webeos.docs.cern.ch/matomo/',
    usability: UsabilityOptions.EASY,
    url: 'https://webeos.docs.cern.ch/matomo/',
  },
};

const webContentManagement = {
  name: 'webContent',
  icon: webContentIcon,
  title: 'Web Content Management',
  description:
    'Create fully-fledged projects and organizational sites with content management and WSIWG editor.',
  learnMore: 'https://webservices-portal.web.cern.ch',
  services: webContentManagementServices,
};

const documentation = {
  name: 'documentation',
  icon: documentationIcon,
  title: 'Documentation',
  description:
    "Create structured documentation for a service, build your project's knowledge base, work on publications.",
  learnMore: 'https://webservices-portal.web.cern.ch',
  services: documentationServices,
};

const communication = {
  name: 'communication',
  icon: communicationIcon,
  title: 'Communication',
  description:
    'Allow your community to discuss specific topics and get their answers quickly. Prepare surveys, send newsletters and alerts.',
  learnMore: 'https://webservices-portal.web.cern.ch',
  services: communicationServices,
};

const hosting = {
  name: 'hosting',
  icon: hostingIcon,
  title: 'Web Application & Site Hosting',
  description: 'Expose your self-made website and share content with others.',
  learnMore: 'https://webservices-portal.web.cern.ch',
  services: hostingServices,
};

const softwareDevelopment = {
  name: 'softwareDevelopment',
  icon: softwareDevIcon,
  title: 'Software development',
  description:
    'Get support for the whole software lifecycle: issue tracking, version control, continuous integration and deployment, repository management, and others.',
  learnMore: 'https://webservices-portal.web.cern.ch',
  services: softwareDevelopmentServices,
};

const monitoringSolutions = {
  name: 'monitoring',
  icon: monitoringIcon,
  title: 'Monitoring Solutions',
  description:
    'Add analytics to your website, get insight into your application performance and identify operational problems with no hassle.',
  learnMore: 'https://webservices-portal.web.cern.ch',
  services: monitoringServices,
};

export const categories = [
  webContentManagement,
  documentation,
  communication,
  hosting,
  softwareDevelopment,
  monitoringSolutions,
];
